import { useTranslation } from 'react-i18next'

import { styled, SxProps, Theme } from '@mui/material/styles'
import { BadgeProps, Fab, Tooltip, Badge } from '@mui/material'

import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import ControlBarItem from '@/components/chime-sdk/controls/ControlBarItem'

type ConnectionIndicatorProps = {
  connectedPeers: string[]
  sx?: SxProps<Theme>
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 0,
    top: 4,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))

export default function ConnectionIndicator(props: ConnectionIndicatorProps) {
  const { connectedPeers, sx = [] } = props
  // show green icon if length > 0 red if not

  const connected = connectedPeers.length > 0
  const { t } = useTranslation()
  return (
    <>
      <StyledBadge badgeContent={connectedPeers.length} color="primary">
        <ControlBarItem>
          <Tooltip title={connected ? t('component.ui.ConnectedIndicator.connected') : t('component.ui.ConnectedIndicator.disconnected')}>
            <Fab size="small" color={connected ? 'success' : 'error'} sx={[...(Array.isArray(sx) ? sx : [sx])]}>
              <ConnectWithoutContactIcon />
            </Fab>
          </Tooltip>
        </ControlBarItem>
      </StyledBadge>
    </>
  )
}
